import type {
  SendMoneyFlowType,
  TransferKind,
  TransferScheme,
  TransferStatusRouteKind,
} from './send-money.types';

export const FLOW_KEYS: Record<SendMoneyFlowType, string> = {
  'new-recipient': 'new-recipient',
  'existing-contact': 'existing-contact',
  myself: 'myself',
} as const;

export const TRANSFER_KINDS: Record<SendMoneyFlowType, TransferKind> = {
  'new-recipient': 'external',
  'existing-contact': 'external',
  myself: 'internal',
} as const;

export const CHALLENGE_POLLING_INTERVAL_MS = 5000;

export const CHALLENGE_NOT_FOUND_ERROR_CODE = 'CHALLENGES.NOT_FOUND';

export const SEND_MONEY_ROUTE_NAME = 'send-money';
export const SEND_MONEY_ADD_CONTACT_ROUTE_NAME = 'send-money-add-contact';
export const PAYMENT_PROCESSED_ROUTE_NAME = 'payment-processed';

export const CHALLENGE_STATUS_QUERY_KEY = 'challengeId';
export const TRANSFER_ID_QUERY_KEY = 'transferId';
export const TRANSFER_KIND_QUERY_KEY = 'kind';

export const STATUS_ROUTE_QUERY_KEYS = {
  kind: TRANSFER_KIND_QUERY_KEY,
  challengeId: CHALLENGE_STATUS_QUERY_KEY,
  transferId: TRANSFER_ID_QUERY_KEY,
} as const;

export const TRANSFER_STATUS_ROUTE_KINDS: TransferStatusRouteKind[] = [
  'external-challenge',
  'internal-challenge',
  'external-direct',
  'internal-direct',
];

export const DEFAULT_CURRENCY = 'EUR';
export const SEND_MONEY_FLOW_START_STEP = '1';
export const EXISTING_CONTACT_DETAILS_STEP = '2';

export const SUPPORTED_CURRENCIES = ['EUR', 'GBP'] as const;

export const MIN_TRANSFER_AMOUNT_MINOR = 1;

export const BENEFICIARY_REQUIREMENT_REGEX_MAX_LENGTH = 256;
export const BENEFICIARY_REQUIREMENT_VALUE_MAX_LENGTH = 150;

/**
 * Updated on 09/07/2026 to fix a problem with banks not supporting sepa-instant payments in most cases
 * TODO:  TBC when it can be switched back or removed
 */
export const EXTERNAL_TRANSFER_DEFAULT_SCHEME = 'sepa' as const;

export const TRANSFER_SCHEMES: TransferScheme[] = [
  'swift',
  'local',
  'sepa',
  'sepa-instant',
  'sepa-target-2',
  'sepa-target-2-pacs009',
  'chaps',
  'bacs',
  'faster-payments',
  'faster-payments-poo',
  'ach',
  'wire',
  'eft',
];

export const INSTANT_TRANSFER_DATE_LABEL_SCHEMES: TransferScheme[] = ['sepa-instant'];

export const INSTANT_TRANSFER_DATE_LABEL = 'Pay instantly';

export const REQUIRED_BANK_ROUTING_CODES_BY_SCHEME: Partial<
  Record<TransferScheme, readonly string[]>
> = {
  sepa: ['bic'],
  'sepa-instant': ['bic'],
};
